// middleware/AuthMiddleware.js
import { useEffect, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { AuthContext } from "./contexts/AuthContext";

const AuthMiddleware = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated, isLoading, user } = useContext(AuthContext);
  const userType = user?.user_type;

  useEffect(() => {
    if (isLoading) return;

    const publicRoutes = [
      "/login",
      "/set-password",
      "/",
      "/home",
      "/contact",
      "/about",
      "/forget-password",
      "/access-denied",
    ];

    const adminRoutes = [
      "/clients",
      "/details",
      "/partialdetails",
      "/detailedoverview",
      "/reports/property",
      "/reports/statistics",
      "/reports/element",
      "/reports/information",
      "/reports/linkinformation",
    ];

    const isPublicRoute =
      publicRoutes.includes(location.pathname) || location.pathname.startsWith("/shared/");
    const isAdminRoute = adminRoutes.some(
      (route) => location.pathname === route || location.pathname.startsWith(`${route}/`),
    );

    if (!isAuthenticated && !isPublicRoute) {
      navigate("/login", { state: { from: location.pathname } });
      return;
    }

    if (
      isAuthenticated &&
      typeof userType === "string" &&
      userType.startsWith("contractor_") &&
      user?.is_profile_completed === false &&
      location.pathname !== "/onboard/contractor"
    ) {
      navigate("/onboard/contractor", { replace: true });
      return;
    }

    if (
      isAuthenticated &&
      location.pathname === "/onboard/contractor" &&
      typeof userType === "string" &&
      userType.startsWith("contractor_") &&
      user?.is_profile_completed
    ) {
      navigate("/dashboard", { replace: true });
      return;
    }

    if (isAuthenticated && location.pathname === "/") {
      navigate("/dashboard/", { replace: true });
      return;
    }

    if (isAuthenticated && isAdminRoute && userType !== "admin") {
      navigate("/dashboard/", { replace: true });
      return;
    }
  }, [
    location.pathname,
    navigate,
    isAuthenticated,
    isLoading,
    userType,
    user?.is_profile_completed,
  ]);

  if (isLoading) {
    return null;
  }

  return children;
};

export default AuthMiddleware;
